"use strict";
import './Text-Editor.less';
import React, { Component } from 'react';
import { EditorState, convertToRaw,ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';

/* 
 * Simple editor component that takes placeholder text as a prop 
 */
class EditorConvertToHTML extends React.Component {
  constructor (props) {
    super(props)
    // console.log("enter in text editor constructor", props.value);
    // const html = '<p>Hey this <strong>editor</strong> rocks 😀</p>';
    // console.log('html email is:', JSON.stringify(props));
    const contentBlock = htmlToDraft(props.value);
    // const contentBlock = htmlToDraft(html);

    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      // console.log("editorState========",editorState);
      this.state = {
        editorState,
      };
    }
  }
  componentWillReceiveProps(newProps){
    // console.log("enter in text editor componentWillReceiveProps", newProps.value.length, this.props.value.length);
    if(newProps.value === this.props.value) return;
    // console.log("redy to update editor");
    const contentBlock = htmlToDraft(newProps.value);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
      };
    }
  }
  componentWillUnmount(){
    console.log("enter in will unmount");
  }

  // handleChange (html) {
  //   this.setState({ editorHtml: html });
  //   this.props.onChange(html);
  // }
  onEditorStateChange = (editorState)=>{
    // console.log("enter in change",editorState);
    this.setState({editorState});
    let html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    console.log('html=====',html);
    this.props.onChange(html);
  }
  handleThemeChange (newTheme) {
    if (newTheme === "core") newTheme = null;
    this.setState({ theme: newTheme })
  }
  
  render () {
    const { editorState } = this.state;
    return (
      <div className="app-editor">
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onEditorStateChange}
        />
        {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))} */}
        {/* /> */}
      </div>
    );

    // return (
    //   <div className="app-editor">
    //     <ReactQuill 
    //       theme={this.state.theme}
    //       onChange={this.handleChange}
    //       value={this.state.editorHtml}
    //       modules={Editor.modules}
    //       formats={Editor.formats}
    //       bounds={'.app-editor'}
    //       placeholder={this.props.placeholder}
    //      />
    //   </div>
    //  )
  }
}

/* 
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
// Editor.modules = {
//   toolbar: [
//     [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
//     [{size: []}],
//     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//     [{'list': 'ordered'}, {'list': 'bullet'}, 
//      {'indent': '-1'}, {'indent': '+1'}],
//     ['link', 'image', 'video'],
//     ['clean']
//   ],
//   clipboard: {
//     // toggle to add extra line breaks when pasting HTML:
//     matchVisual: false,
//   }
// }
/* 
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
// Editor.formats = [
//   'header', 'font', 'size',
//   'bold', 'italic', 'underline', 'strike', 'blockquote',
//   'list', 'bullet', 'indent',
//   'link', 'image', 'video'
// ]

/* 
 * PropType validation
 */
// Editor.propTypes = {
//   placeholder: React.PropTypes.string,
// }

/* 
 * Render component on page
 */
// ReactDOM.render(
//   <Editor placeholder={'Write something...'}/>, 
//   document.querySelector('.app')
// )

export default EditorConvertToHTML;

